import { defineMessages } from 'react-intl';

/** The ways into the directed video (design directed-video a1 to a4). */
export const entryMessages = defineMessages({
  button: { id: 'app.sml.musicVideo.directed.entry.button', defaultMessage: 'Directed video' },
  // QA finding F21: two short lines in plain words, no "clip bank".
  hintWhat: {
    id: 'app.sml.musicVideo.directed.entry.hintWhat',
    defaultMessage: 'An AI director writes a story for this song and films new shots that only you have.',
  },
  hintPrice: {
    id: 'app.sml.musicVideo.directed.entry.hintPrice',
    defaultMessage: 'About {credits} credits for each 8 seconds of new video.',
  },
  hintNeedsPlan: {
    id: 'app.sml.musicVideo.directed.entry.hintNeedsPlan',
    defaultMessage:
      'The new shots are AI footage. AI footage needs Pro or a bigger plan. The trial and Free do not make it.',
  },
  runStep: { id: 'app.sml.musicVideo.directed.entry.runStep', defaultMessage: 'Step {number} of {count}' },
  runCast: { id: 'app.sml.musicVideo.directed.entry.runCast', defaultMessage: 'Cast · not paid yet' },
  runStories: { id: 'app.sml.musicVideo.directed.entry.runStories', defaultMessage: 'Story ideas · not paid yet' },
  runStyle: { id: 'app.sml.musicVideo.directed.entry.runStyle', defaultMessage: 'Style · not paid yet' },
  runScript: {
    id: 'app.sml.musicVideo.directed.entry.runScript',
    defaultMessage: 'Script ready · {count, plural, one {# shot} other {# shots}} · not paid yet',
  },
  runScriptWorking: {
    id: 'app.sml.musicVideo.directed.entry.runScriptWorking',
    defaultMessage: 'Script · not paid yet',
  },
  runPrice: { id: 'app.sml.musicVideo.directed.entry.runPrice', defaultMessage: 'Price ready · not paid yet' },
  continue: { id: 'app.sml.musicVideo.directed.entry.continue', defaultMessage: 'Continue' },
  makingCount: { id: 'app.sml.musicVideo.directed.entry.makingCount', defaultMessage: '{done} of {total}' },
  makingShots: { id: 'app.sml.musicVideo.directed.entry.makingShots', defaultMessage: 'Making the shots' },
  rendering: { id: 'app.sml.musicVideo.directed.entry.rendering', defaultMessage: 'Rendering the video' },
  eta: {
    id: 'app.sml.musicVideo.directed.entry.eta',
    defaultMessage: '{line} · about {minutes, plural, one {# min} other {# min}}',
  },
  seeProgress: { id: 'app.sml.musicVideo.directed.entry.seeProgress', defaultMessage: 'See the progress' },
  // A ready video (a2 "Ready")
  ready: { id: 'app.sml.musicVideo.directed.entry.ready', defaultMessage: 'Ready' },
  readyLine: {
    id: 'app.sml.musicVideo.directed.entry.readyLine',
    defaultMessage:
      'The finished cut opens in the music video editor. Its shots are in Footage → Yours, free to use in every video of this workspace.',
  },
  // The Studio card (a4)
  studioLine: {
    id: 'app.sml.musicVideo.directed.entry.studioLine',
    defaultMessage: 'A story, a style and new shots made for this song, with you in them if you add your photos.',
  },
  studioPrice: {
    id: 'app.sml.musicVideo.directed.entry.studioPriceLength',
    defaultMessage: '{credits} credits for 8 s of new footage · you see the price first',
  },
});
